// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3fNaA","head":"Table_head__2I7oi","col":"Table_col__2uZi3"};